const drinks = [

    {   name: "Узвар", 
        category: 'Напої', 
        unit: ' л', 
        amount: 1, 
        price: 90, 
        image: "",
        ingredients: ''  
    },

    {   name: "Лимонад", 
        category: 'Напої', 
        unit: ' л', 
        amount: 1, 
        price: 100, 
        image: "",
        ingredients: ''  
    },

    {   name: "Сік в асортименті", 
        category: 'Напої', 
        unit: ' л', 
        amount: 1, 
        price: 80, 
        image: "",
        ingredients: ''  
    },

    {   name: "Напій Coca-Cola 1л", 
        category: 'Напої', 
        unit: ' л', 
        amount: 1, 
        price: 75, 
        image: "",
        ingredients: ''  
    },

    {   name: "Вода мінеральна лікувально-столова Бонаква негазована та газована /скло/", 
        category: 'Напої', 
        unit: ' л', 
        amount: "0.33", 
        price: 30, 
        image: "",
        ingredients: ''  
    },

];

export default drinks;